import * as ng from 'angular';
import { SiteConfig } from '../shared';

export interface EventDetail {
   eventID:number;
   timeSlotID:number;
   name:string;
   startDateTime:string;
   endDateTime:string;
   timezoneId:string;

   id:number;
   address:string;
   city:string;
   state:string;
   stateCode:string;
   country:string;
   countryCode:string;
   postalCode:string;
   regionDescription:string;
   directionsURL:string;
   isFull:boolean;
   isClosed:boolean;
   isPrivate:boolean;
   hideAddress:boolean;
   hasPasscode:boolean;
   lat:number;
   lng:number;

   settings:{
      [key:string]:{
         [key:string]:string
      }
   }
}

export interface EventCountry {
   count: number; // # of events scheduled in country
   code: string;  // country code
   name: string;  // country name
}

export class EventListService {
   static $inject = ['$http', 'config'];

   constructor(private $http:ng.IHttpService, private config:SiteConfig) { }

   list(coords?:Coordinates) {
      let args = '';

      if (coords) {
         let radius = this.config.settings.gatewayRadiusMeters;
         args = `?lat=${coords.latitude}&lng=${coords.longitude}&radius=${radius}`;
      }

      let url = `//${this.config.apiDomain}/api/selfReg/events/${this.config.campaign.slug}${args}`;

      return this.$http.get<EventDetail[]>(url)
         .then((result) => result.data);
   }

   get(id:number) {
      let url = `//${this.config.apiDomain}/api/rsvp/${this.config.campaign.slug}/events/${id}`;
      return this.$http.get<EventDetail>(url)
         .then((result) => result.data);
   }

   getCountriesByName() {
      const url = `//${this.config.apiDomain}/api/rsvp/${this.config.campaign.slug}/events/countries/byName`;

      return this.$http.get<EventCountry[]>(url).then((result) => {
         const list = result.data;
         if (list && list.length > 0) {
            const countryWithMostEvents = list.reduce((max, curr) =>
               curr.count > max.count ? curr : max
            );

            return {
               country: countryWithMostEvents.code,
               list: list,
            };
         } else {
            return null;
         }
      });
   }
}

ng.module('selfReg')
   .service('eventListService', EventListService);
